import React, {useEffect, useState} from "react";
import {Box, Tooltip, Typography} from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {blue} from "@mui/material/colors";

import SessionReport from "./SessionReport";

const styles = {
    tooltipPopper: {
        sx: {
            '& .MuiTooltip-tooltip': {
                borderRadius: '2rem'
            }
        }
    },
    tooltipBox: {
        whiteSpace: 'pre-line'
    },
    infoIcon: {
        marginLeft: '0.5rem',
        fontSize: '1rem',
        color: 'black'
    }
};

const buildAttendanceReportTextStyle = (useHighContrast) => ({
    color: useHighContrast ? 'black' : blue[600],
    fontSize: '0.75rem',
    fontWeight: !useHighContrast && 600,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flexShrink: 0,
});

export default function HistoricalSessionTooltip({serviceType, attendanceReport, useHighContrast}) {

    const attendanceReportTextStyle = buildAttendanceReportTextStyle(useHighContrast);

    const completeAttendanceReport = attendanceReport?.map(report =>
        {return {currentServiceType: report.serviceTypeKeycode === serviceType, ...report}});

    const currentServiceReport = completeAttendanceReport?.find(report => report.currentServiceType);

    const [currentServiceTypeAttendanceReportSummary, setCurrentServiceTypeAttendanceReportSummary] = useState("");
    const [allServiceTypeAttendanceReportSummary, setAllServiceTypeAttendanceReportSummary] = useState("");

    useEffect(() => {
        const attendanceReportForAllServiceTypes = completeAttendanceReport
            ?.map(report => buildSessionReport(report))
            .sort((serviceType1, serviceType2) => serviceType1.props.serviceType.localeCompare(serviceType2.props.serviceType));

        setAllServiceTypeAttendanceReportSummary(attendanceReportForAllServiceTypes);

        if (currentServiceReport) {
            setCurrentServiceTypeAttendanceReportSummary(buildSessionReport(currentServiceReport));
        }
    }, [serviceType, attendanceReport]);

    const buildSessionReport = (report) =>
      <SessionReport
        serviceType={report.serviceTypeKeycode}
        countOfSessions={report.countOfAttendedSessions}
        countOfSessionsWithPerformer={report.countOfAttendedSessionsWithPerformer}/>;

    if (!currentServiceReport) {
        return null;
    }

    return <>
        <Tooltip arrow title={<Box style={styles.tooltipBox}>{currentServiceTypeAttendanceReportSummary}</Box>} PopperProps={styles.tooltipPopper}>
            <Typography variant="caption" style={attendanceReportTextStyle}>
                {currentServiceReport.countOfAttendedSessions} ({currentServiceReport.countOfAttendedSessionsWithPerformer})
            </Typography>
        </Tooltip>

        <Tooltip arrow title={allServiceTypeAttendanceReportSummary} PopperProps={styles.tooltipPopper}>
            <InfoOutlinedIcon fontSize='small' style={styles.infoIcon}/>
        </Tooltip>
    </>;
}
